import React, { useState, useRef } from 'react';
import { Link2 } from 'lucide-react';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Button } from '@/components/ui/button';
import { PlatformLinkPicker, insertLinkAtCaret } from './PlatformLinkPicker';

/**
 * A text area you can drop platform links into.
 *
 * Select the words you want linked, press "Insert platform link", pick the destination — the
 * selected words become the link. With nothing selected it inserts the destination's own name.
 */
export function LinkableTextarea({
  label, value, onChange, rows = 8, placeholder = '', hint = '', testid = 'linkable-textarea',
}) {
  const [picking, setPicking] = useState(false);
  const ref = useRef(null);

  const insert = (item) => {
    const { value: next, caret } = insertLinkAtCaret(ref.current, value || '', item);
    onChange(next);
    requestAnimationFrame(() => {
      if (ref.current) {
        ref.current.focus();
        ref.current.setSelectionRange(caret, caret);
      }
    });
  };

  return (
    <div>
      <div className="flex items-center justify-between gap-2">
        {label && <Label>{label}</Label>}
        <Button type="button" size="sm" variant="outline" className="border-white/20 text-gray-100 hover:bg-white/10" onClick={() => setPicking(true)}
          data-testid={`${testid}-link-btn`}>
          <Link2 className="w-3.5 h-3.5 mr-1" /> Insert platform link
        </Button>
      </div>
      <Textarea
        ref={ref}
        value={value || ''}
        rows={rows}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        data-testid={testid}
      />
      {hint && <p className="text-xs text-gray-500 mt-1">{hint}</p>}
      {picking && <PlatformLinkPicker onInsert={insert} onClose={() => setPicking(false)} />}
    </div>
  );
}

export default LinkableTextarea;
